import { BookOpen } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function HandbookPoliciesPage() {
  return (
    <PhaseStubPage
      title="Handbook & Policies"
      phase={6}
      modules={[
        'Versioned employee handbook with effective dates',
        'Policy library (conduct, remote work, leave, IT, etc.)',
        'Required acknowledgement tracking per employee',
        'Change notifications when a policy is updated',
      ]}
      icon={BookOpen}
    />
  );
}
